import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';

const aboutJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于爆料吃瓜网',
  description: '爆料吃瓜网成立于2019年，是国内领先的娱乐八卦资讯聚合平台，覆盖明星八卦、网红黑料、综艺爆料、影视吃瓜等多个领域。',
  url: 'http://wjf5l.cn/about',
  isPartOf: {
    '@type': 'WebSite',
    name: '爆料吃瓜网',
    url: 'http://wjf5l.cn/',
  },
  about: {
    '@type': 'Organization',
    name: '爆料吃瓜网',
    url: 'http://wjf5l.cn/',
    description: '爆料吃瓜网是国内领先的娱乐八卦资讯聚合平台，提供91爆料吃瓜官网入口与App下载，实时追踪网红黑料、明星八卦和全网热议大瓜。',
    foundingDate: '2019',
    contactPoint: [
      {
        '@type': 'ContactPoint',
        contactType: 'business cooperation',
        email: 'hello@wjf5l.cn',
        description: '商务合作 / 广告投放',
      },
      {
        '@type': 'ContactPoint',
        contactType: 'legal',
        email: 'hello@wjf5l.cn',
        description: '侵权投诉 / 内容下架',
      },
      {
        '@type': 'ContactPoint',
        contactType: 'news tip',
        email: 'hello@wjf5l.cn',
        description: '爆料投稿',
      },
    ],
    sameAs: ['http://wjf5l.cn/'],
  },
};

const breadcrumbJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: '首页',
      item: 'http://wjf5l.cn/',
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: '关于我们',
    },
  ],
};

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('company_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setFormStatus('success');
      setFormMessage('感谢您的留言，我们会尽快与您联系！');
      form.reset();
      return;
    }

    setFormStatus('loading');
    setFormMessage('');

    try {
      const response = await fetch('http://wjf5l.cn/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(
          Array.from(formData.entries())
            .filter(([key]) => key !== 'company_alt')
            .map(([key, value]) => [key, String(value)])
        ).toString(),
      });

      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // use raw text as fallback
      }

      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormMessage('感谢您的留言！我们会尽快与您联系。');
        form.reset();
      } else if (serverMsg && (String(serverMsg).includes('spam') || String(serverMsg).includes('form data is spam'))) {
        setFormStatus('error');
        setFormMessage(serverMsg || '提交失败，请稍后重试。');
      } else {
        setFormStatus('error');
        setFormMessage(serverMsg || '提交失败，请稍后重试。');
      }
    } catch {
      setFormStatus('error');
      setFormMessage('网络异常，请检查网络后重试。');
    }
  };

  return (
    <>
      <JsonLd data={aboutJsonLd} />
      <JsonLd data={breadcrumbJsonLd} />
      <Navbar />
      <main className="pt-20 pb-16 bg-background-50">
        <div className="px-4 md:px-6 lg:px-10">
          <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-8" aria-label="面包屑导航">
            <Link to="/" className="hover:text-accent-400 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-300">关于我们</span>
          </nav>

          <div className="max-w-5xl mx-auto">
            <section className="mb-20">
              <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
                <div className="lg:w-[55%]">
                  <p className="text-xs text-foreground-500 tracking-wider mb-3">关于爆料吃瓜网</p>
                  <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-black text-foreground-50 mb-6 leading-tight">
                    全网最快的<br />吃瓜资源平台
                  </h1>
                  <div className="text-base leading-relaxed text-foreground-300 space-y-4">
                    <p>
                      爆料吃瓜网成立于2019年，是国内领先的娱乐八卦资讯聚合平台。作为<strong className="text-foreground-100">91爆料吃瓜官方指定入口</strong>，我们致力于为全网吃瓜群众提供最新、最快、最全的娱乐八卦资讯，覆盖明星八卦、网红黑料、综艺爆料、影视吃瓜等多个领域。
                    </p>
                    <p>
                      我们的团队由资深娱乐记者、专业爆料人和技术精英组成，全天候24小时追踪娱乐圈最新动态，确保用户能够在第一时间获取最热门的吃瓜内容。平台累计发布超过10,000条独家爆料帖，签约超过500位一线爆料人。
                    </p>
                    <p>
                      爆料吃瓜网始终坚持「真实、快速、全面」的内容理念，以98%的爆料准确率赢得了广大用户的信赖，已成为中文互联网最具影响力的吃瓜资源平台之一。我们不仅提供PC端网站服务，还推出了爆料吃瓜App，支持iOS和Android双平台下载。
                    </p>
                  </div>
                </div>

                <div className="lg:w-[45%] grid grid-cols-2 gap-4 content-start">
                  <div className="rounded-xl bg-background-200 border border-secondary-800/40 p-6 text-center">
                    <div className="text-4xl font-heading font-black text-accent-400 mb-1">10,000+</div>
                    <p className="text-sm text-foreground-500">累计爆料帖</p>
                  </div>
                  <div className="rounded-xl bg-background-200 border border-secondary-800/40 p-6 text-center">
                    <div className="text-4xl font-heading font-black text-primary-400 mb-1">500+</div>
                    <p className="text-sm text-foreground-500">签约爆料人</p>
                  </div>
                  <div className="rounded-xl bg-background-200 border border-secondary-800/40 p-6 text-center">
                    <div className="text-4xl font-heading font-black text-accent-400 mb-1">98%</div>
                    <p className="text-sm text-foreground-500">爆料准确率</p>
                  </div>
                  <div className="rounded-xl bg-background-200 border border-secondary-800/40 p-6 text-center">
                    <div className="text-4xl font-heading font-black text-primary-400 mb-1">50万+</div>
                    <p className="text-sm text-foreground-500">日活跃用户</p>
                  </div>
                </div>
              </div>
            </section>

            <section className="mb-20">
              <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-50 mb-8">
                平台口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="rounded-xl bg-background-200 border border-secondary-800/40 p-6">
                  <div className="flex items-center gap-1 mb-3">
                    {[1, 2, 3, 4, 5].map((i) => (
                      <i key={i} className="ri-star-fill text-primary-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-400 leading-relaxed mb-4">
                    "爆料吃瓜网是我每天必刷的平台，更新速度全网最快，内容质量也很高。特别是App版本，推送及时又没有乱七八糟的广告，体验非常好。"
                  </p>
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-secondary-800 flex items-center justify-center">
                      <i className="ri-user-line text-xs text-foreground-400"></i>
                    </div>
                    <div>
                      <p className="text-xs font-medium text-foreground-200">@吃瓜一线</p>
                      <p className="text-xs text-foreground-600">微博用户</p>
                    </div>
                  </div>
                </div>
                <div className="rounded-xl bg-background-200 border border-secondary-800/40 p-6">
                  <div className="flex items-center gap-1 mb-3">
                    {[1, 2, 3, 4, 5].map((i) => (
                      <i key={i} className="ri-star-fill text-primary-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-400 leading-relaxed mb-4">
                    "做娱乐自媒体三年了，爆料吃瓜一直是我的主要素材来源。独家内容多，分类清晰，找素材特别方便。已经推荐给身边所有做娱乐内容的朋友了。"
                  </p>
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-secondary-800 flex items-center justify-center">
                      <i className="ri-user-line text-xs text-foreground-400"></i>
                    </div>
                    <div>
                      <p className="text-xs font-medium text-foreground-200">@娱乐研究员</p>
                      <p className="text-xs text-foreground-600">小红书博主</p>
                    </div>
                  </div>
                </div>
                <div className="rounded-xl bg-background-200 border border-secondary-800/40 p-6">
                  <div className="flex items-center gap-1 mb-3">
                    {[1, 2, 3, 4, 5].map((i) => (
                      <i key={i} className="ri-star-fill text-primary-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-400 leading-relaxed mb-4">
                    "App Store给了4.9分实至名归！界面清爽、无冗余广告、推送克制。是我用过最舒服的八卦资讯App，每天打开已经成习惯了。"
                  </p>
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-secondary-800 flex items-center justify-center">
                      <i className="ri-user-line text-xs text-foreground-400"></i>
                    </div>
                    <div>
                      <p className="text-xs font-medium text-foreground-200">@深夜刷瓜人</p>
                      <p className="text-xs text-foreground-600">App Store用户</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-50 mb-6">
                  联系我们
                </h2>
                <div className="space-y-4">
                  <div className="rounded-xl bg-background-200 border border-secondary-800/40 p-5">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-full bg-accent-500/10 border border-accent-500/20 flex items-center justify-center flex-shrink-0">
                        <i className="ri-mail-line text-accent-400"></i>
                      </div>
                      <div>
                        <h3 className="text-base font-bold text-foreground-50 mb-1">商务合作 / 广告投放</h3>
                        <p className="text-sm text-foreground-500 mb-1">
                          广告投放、品牌推广、内容合作、活动联名等商务洽谈
                        </p>
                        <a
                          href="mailto:hello@wjf5l.cn"
                          className="text-sm text-accent-400 hover:text-accent-300 transition-colors"
                        >
                          hello@wjf5l.cn
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="rounded-xl bg-background-200 border border-secondary-800/40 p-5">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-full bg-primary-500/10 border border-primary-500/20 flex items-center justify-center flex-shrink-0">
                        <i className="ri-alert-line text-primary-400"></i>
                      </div>
                      <div>
                        <h3 className="text-base font-bold text-foreground-50 mb-1">侵权投诉 / 内容下架</h3>
                        <p className="text-sm text-foreground-500 mb-1">
                          版权投诉、内容下架申请、律师函接收
                        </p>
                        <a
                          href="mailto:hello@wjf5l.cn"
                          className="text-sm text-accent-400 hover:text-accent-300 transition-colors"
                        >
                          hello@wjf5l.cn
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="rounded-xl bg-background-200 border border-secondary-800/40 p-5">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-full bg-accent-500/10 border border-accent-500/20 flex items-center justify-center flex-shrink-0">
                        <i className="ri-send-plane-line text-accent-400"></i>
                      </div>
                      <div>
                        <h3 className="text-base font-bold text-foreground-50 mb-1">爆料投稿</h3>
                        <p className="text-sm text-foreground-500 mb-1">
                          独家爆料线索投稿，丰厚报酬，严格保护隐私
                        </p>
                        <a
                          href="mailto:hello@wjf5l.cn"
                          className="text-sm text-accent-400 hover:text-accent-300 transition-colors"
                        >
                          hello@wjf5l.cn
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="rounded-xl bg-background-200 border border-secondary-800/40 p-5">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-full bg-primary-500/10 border border-primary-500/20 flex items-center justify-center flex-shrink-0">
                        <i className="ri-download-2-line text-primary-400"></i>
                      </div>
                      <div>
                        <h3 className="text-base font-bold text-foreground-50 mb-1">App下载</h3>
                        <p className="text-sm text-foreground-500 mb-2">
                          扫描二维码或在各大应用商店搜索「爆料吃瓜」下载
                        </p>
                        <div className="flex items-center gap-3">
                          <span className="px-3 py-1 text-xs rounded-full bg-accent-500/10 text-accent-400 border border-accent-500/20">
                            iOS版
                          </span>
                          <span className="px-3 py-1 text-xs rounded-full bg-primary-500/10 text-primary-400 border border-primary-500/20">
                            Android版
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-50 mb-6">
                  商务合作咨询
                </h2>
                <form
                  id="business-contact-form"
                 
                  onSubmit={handleSubmit}
                  className="rounded-xl bg-background-200 border border-secondary-800/40 p-6 space-y-4"
                >
                  <div>
                    <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-300 mb-1.5">
                      您的姓名 <span className="text-accent-400">*</span>
                    </label>
                    <input
                      type="text"
                      id="contact-name"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-secondary-700/50 text-sm text-foreground-100 placeholder:text-foreground-600 focus:outline-none focus:border-accent-500 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>

                  <div>
                    <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-300 mb-1.5">
                      电子邮箱 <span className="text-accent-400">*</span>
                    </label>
                    <input
                      type="email"
                      id="contact-email"
                      name="email"
                      required
                      className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-secondary-700/50 text-sm text-foreground-100 placeholder:text-foreground-600 focus:outline-none focus:border-accent-500 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>

                  <div>
                    <label htmlFor="contact-company" className="block text-sm font-medium text-foreground-300 mb-1.5">
                      公司/品牌名称
                    </label>
                    <input
                      type="text"
                      id="contact-company"
                      name="company"
                      className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-secondary-700/50 text-sm text-foreground-100 placeholder:text-foreground-600 focus:outline-none focus:border-accent-500 transition-colors"
                      placeholder="请输入公司或品牌名称"
                    />
                  </div>

                  <div>
                    <label htmlFor="contact-type" className="block text-sm font-medium text-foreground-300 mb-1.5">
                      合作类型 <span className="text-accent-400">*</span>
                    </label>
                    <select
                      id="contact-type"
                      name="cooperation_type"
                      required
                      className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-secondary-700/50 text-sm text-foreground-100 focus:outline-none focus:border-accent-500 transition-colors appearance-none"
                    >
                      <option value="">请选择合作类型</option>
                      <option value="广告投放">广告投放</option>
                      <option value="品牌推广">品牌推广</option>
                      <option value="内容合作">内容合作</option>
                      <option value="活动联名">活动联名</option>
                      <option value="其他">其他合作</option>
                    </select>
                  </div>

                  <div>
                    <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-300 mb-1.5">
                      合作说明 <span className="text-accent-400">*</span>
                    </label>
                    <textarea
                      id="contact-message"
                      name="message"
                      required
                      rows={4}
                      maxLength={500}
                      className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-secondary-700/50 text-sm text-foreground-100 placeholder:text-foreground-600 focus:outline-none focus:border-accent-500 transition-colors resize-none"
                      placeholder="请简要描述您的合作需求（500字以内）"
                    ></textarea>
                    <p className="text-xs text-foreground-600 mt-1 text-right">最多500字</p>
                  </div>

                  <div className="business-hp-wrapper">
                    <label htmlFor="contact-company-alt" className="block text-sm font-medium text-foreground-300 mb-1.5">
                      备用联系方式
                    </label>
                    <input
                      type="text"
                      id="contact-company-alt"
                      name="company_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                      className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-secondary-700/50 text-sm text-foreground-100 placeholder:text-foreground-600 focus:outline-none"
                      placeholder="请勿填写"
                    />
                  </div>

                  <button
                    type="submit"
                    disabled={formStatus === 'loading'}
                    className="w-full py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-400 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 whitespace-nowrap"
                  >
                    {formStatus === 'loading' ? '提交中...' : '提交合作咨询'}
                  </button>

                  {formStatus === 'success' && (
                    <div className="p-3 rounded-lg bg-accent-500/10 border border-accent-500/20">
                      <p className="text-sm text-accent-400 flex items-center gap-2">
                        <i className="ri-check-line"></i>
                        {formMessage}
                      </p>
                    </div>
                  )}

                  {formStatus === 'error' && (
                    <div className="p-3 rounded-lg bg-red-500/10 border border-red-500/20">
                      <p className="text-sm text-red-400 flex items-center gap-2">
                        <i className="ri-error-warning-line"></i>
                        {formMessage}
                      </p>
                    </div>
                  )}
                </form>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}